export default __webpack_public_path__ + "static/media/article-1.ff91e5b2.png";